<main>
  <div class="container">
    <div class="row mt-5 pt-md-5 mb-sm-5">
      <div class="col-sm-12" style="margin-bottom:12px">
        <div class="arrow-iconslide">
          <div style="float: left;">
            <a (click)="back()" class="pointer">
              <span style="color:#000000; font-size: 18px;font-weight: 500; ">{{ 'Home' | translate }}</span>
            </a>
          </div>
          <a (click)="previousItem()" class="arrowMargin pointer">
            <span><i class="fas fa-arrow-left"></i></span>
          </a>
          <a (click)="nextItem()" class="arrowMargin pointer">
            <span><i class="fas fa-arrow-right"></i></span>
          </a>
        </div>
      </div>
      <div class="col-sm-5 pb-1" (swipeleft)="onSwipe($event)" (swiperight)="onSwipe($event)">
        <div class="detail-banner-slider mb-2" *ngIf="Url_PetId">
          <div class="image-row-dashboard" *ngIf="pet && pet.ThumbnailImagePath" id="ThumbnailImageBlockID">
            <img src="{{  pet.ThumbnailImagePath }}" (click)="openModal($event)" (error)="errorHandler($event)"
              class="hover-shadow-dashboard cursor-dashboard image-class-dashboard ">
            <div class="viking_tag" *ngIf="pet.CompanyLogo"><img src="{{ pet.CompanyLogo }}" /></div>
          </div>
          <div attr.id="{{pet?.LostFoundID}}" class="slide-modal-dashboard modal-center">
            <span class="close-dashboard cursor-dashboard" (click)="closeModal($event)">&times;</span>
            <div class="slide-modal-content-dashboard">
              <img class="images-dashboard image-class-dashboard" src="{{  pet?.ImagePath }}"
                (error)="errorHandler($event)">
            </div>
          </div>
        </div>
        <div class="detail-banner-slider mb-2" *ngIf="Url_ChipId">
          <div class="image-row-dashboard" *ngIf="pet && pet?.PetLostFoundImage" id="ThumbnailImageBlockID">
            <img src="{{pet?.PetLostFoundImage }}" (click)="openModal($event)" (error)="errorHandler($event)"
              class="hover-shadow-dashboard cursor-dashboard image-class-dashboard ">
            <div class="viking_tag" *ngIf="pet && pet.CompanyLogo"><img src="{{ pet.CompanyLogo }}" /></div>
          </div>
          <div attr.id="{{pet?.LostFoundID}}" class="slide-modal-dashboard modal-center">
            <span class="close-dashboard cursor-dashboard" (click)="closeModal($event)">&times;</span>
            <div class="slide-modal-content-dashboard">
              <img class="images-dashboard image-class-dashboard" src="{{ pet?.PetLostFoundImage }}"
                (error)="errorHandler($event)">
            </div>
          </div>
        </div>

        <div class="detail-map-view mt-2 d-none d-sm-block" *ngIf="!pet?.IsNeighbourPet">
          <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [styles]="styles" [disableDefaultUI]="false"
            [streetViewControl]="false">
            <agm-marker [latitude]="lat" [longitude]="lng" [iconUrl]="pet && pet.customMarker"
              [markerDraggable]="false">
            </agm-marker>
          </agm-map>
        </div>
      </div>

      <div class="col-sm-7 pb-3">
        <div class=" details-rightcontent"
          [ngClass]="(pet && pet.OperationTypeID == 2) ? 'lostdarkgreen' : 'lostlightgreen'">
          <h1> {{pet?.PostTitle}} </h1>
          <div>{{pet?.AdditionalInfo}}</div>
          <div class="product-details">
            <div class="product-dtail-inner">
              <div class="pets-details" *ngIf="pet && pet.OperationTypeID == 1">
                <label for="email">{{"Name" | translate }}:</label>
                <div class="details">{{pet?.PetName}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet?.ChipID && pet?.ShowChipNoToOthers">
                <label for="email">{{"Chipnumber" | translate }}:</label>
                <div class="details">{{pet?.ChipID}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.City">
                <label for="email">{{"Area" | translate}}:</label>
                <div class="details" *ngIf="pet.OperationTypeID ==1 ||  pet.OperationTypeID ==2">{{pet.Area}},
                  {{pet.ZipCode}}
                  {{pet?.City}}</div>
                <div class="details" *ngIf="pet.OperationTypeID!=1 && pet.OperationTypeID!=2">{{pet.ZipCode}}
                  {{pet?.City}}</div>
                <!-- <div class="details" *ngIf="IsNeighbourPet==true">{{pet.ZipCode}}, {{pet.City}}</div> -->
              </div>

              <!-- <div class="pets-details" *ngIf="pet.City">
                <label for="email">{{"Area" | translate}}:</label>
                <div class="details" *ngIf="IsNeighbourPet ==true">{{pet.ZipCode}}, {{pet.City}}</div>
              </div> -->

              <div class="pets-details" *ngIf="pet && pet.LostFoundDate && Url_PetId !=''">
                <label for="email">{{ ((pet?.OperationTypeID == "1") ? 'Lost' : 'Found')| translate }}:</label>
                <div class="details">{{pet?.LostFoundDate | date: 'dd.MM.yyyy' }}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.MasterSpecies">
                <label for="email">{{"Species" | translate }}:</label>
                <div class="details">{{pet?.MasterSpecies}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.MasterBreed">
                <label for="email">{{"Breed" | translate }}:</label>
                <div class="details">{{pet?.MasterBreed}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.Gender">
                <label for="email">{{"Gender" | translate }}:</label>
                <div class="details">{{pet?.Gender}} </div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.Age">
                <label for="email" *ngIf="!this.isAgeInMonth">{{"Age" | translate }}<span> ({{ 'Year' |
                    translate}}):</span></label>
                <label for="email" *ngIf="this.isAgeInMonth">{{"Age" | translate }}<span> ({{ 'Month' |
                    translate}}):</span></label>
                <div class="details">{{pet?.Age}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.HairType && pet.HairType != ''">
                <label for="email">{{ 'HairType' | translate }}:</label>
                <div class="details">{{pet?.HairType}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.Color">
                <label for="email">{{ 'Color' | translate }}:</label>
                <div class="details">{{pet?.Color}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.OperationTypeID ==2 && pet.IdentificationMark">
                <label for="email">
                  {{"Identification" | translate }}:</label>
                <div class="details">{{pet.IdentificationMark}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.OperationTypeID ==1 &&  pet.IdentificationMark">
                <label for="email">
                  {{"Identification" | translate }}:</label>
                <div class="details">{{pet.IdentificationMark}}</div>
              </div>
              <div class="pets-details" *ngIf="pet && pet.Company">
                <label for="email">
                  {{ "Company" | translate}}:</label>
                <div class="details">{{pet?.Company}}</div>
              </div>
            </div>
          </div>
          <div class="callto-contact" *ngIf="showReunitePetButton && alreadyReunite">
            <div class="contactpet-btn">
              <button class="btn btn-primary btn-block" mat-raised-button (click)="ReunitePet(pet)">
                {{ 'Re-Unite Pet' | translate}} <i class="fas fa-arrow-right"></i></button>
            </div>
            <div class="scialicon-pet"
              *ngIf="pet && (pet.OperationTypeID ==1 ||  pet.OperationTypeID ==2) && showPrintButton">
              <div class=" print-icon" (click)="generatePDF()"
                [ngStyle]="{'justify-content':!showReunitePetButton ? '' : 'start' }">
                <span class="print-text">{{ 'Print' | translate}} </span>
                <span class="print-icn">
                  <img *ngIf="pet && pet.OperationTypeID==2" src="assets/img/printer-icon.svg" class="img-fluid"
                    alt="" />
                  <img *ngIf="pet && pet.OperationTypeID==1" src="assets/img/printerblack-icon.svg" class="img-fluid"
                    alt="" />
                </span>
              </div>
              <!-- <div class="share-icon" (click)="shareOnFacebook()">
                <span class="print-text">{{ 'Share' | translate}} </span> <span><img
                    src="assets/img/facebook-brands.svg" class="img-fluid" alt="" /></span>
              </div> -->
            </div>
          </div>
          <div class="callto-contact" *ngIf="!showReunitePetButton && alreadyReunite">
            <div class="contactpet-btn">
              <button class="btn btn-primary btn-block" mat-raised-button (click)="openDialog(pet,'menu')">
                {{ 'Contact' | translate}} <i class="fas fa-arrow-right"></i></button>
            </div>

            <div class="scialicon-pet"
              *ngIf="pet && (pet.OperationTypeID ==1 ||  pet.OperationTypeID ==2) && showPrintButton">
              <div class=" print-icon" (click)="generatePDF()"
                [ngStyle]="{'justify-content':!showReunitePetButton ? '' : 'start' }">
                <span class="print-text">{{ 'Print' | translate}} </span> <span class="print-icn">
                  <img *ngIf="pet && pet.OperationTypeID==2" src="assets/img/printer-icon.svg" class="img-fluid"
                    alt="" />
                  <img *ngIf="pet && pet.OperationTypeID==1" src="assets/img/printerblack-icon.svg" class="img-fluid"
                    alt="" />
                </span>
              </div>
              <!--<div class="share-icon" (click)="shareOnFacebook()">
                <span class="print-text">{{ 'Share' | translate}} </span> <span><img
                    src="assets/img/facebook-brands.svg" class="img-fluid" alt="" /></span>
              </div>-->
            </div>
          </div>
        </div>
        <div class="arrow-iconslide">
          <a (click)="previousItem()" class="arrowMargin pointer">
            <span><i class="fas fa-arrow-left"></i></span>
          </a>
          <a (click)="nextItem()" class="arrowMargin pointer">
            <span><i class="fas fa-arrow-right"></i></span>
          </a>
          <!-- <a routerLink="report-lost" class="arrowMargin"><span><i class="fas fa-arrow-right"></i>
                      </span></a> -->
          <!-- <div>
            <a routerLink="report-lost" class="arrowMargin"><span><i class="fas fa-arrow-right"></i>
            </span></a>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row mb-5">
      <div class="col-sm-7">
        <div class="register-heading">
          <h2>Fant ikke det du lette etter? Registrer {{ (pet?.OperationTypeID == 1) ? 'Funnet' : 'Savnet' }}
            kjæledyr.
          </h2>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="register-actionbtn">
          <button *ngIf="pet && pet.OperationTypeID == 1" [routerLink]="['/report-found']" type="button"
            class="btn btn-green">Meld et nytt kjæledyr <span><i class="fas fa-arrow-right"></i>
            </span></button>
          <button *ngIf="pet && pet.OperationTypeID == 2" [routerLink]="['/report-lost']" type="button"
            class="btn btn-green">Meld et nytt kjæledyr <span><i class="fas fa-arrow-right"></i>
            </span></button>
          <button *ngIf="pet && pet.IsNeighbourPet" [routerLink]="['/report-lost']" type="button"
            class="btn btn-green">Meld et nytt kjæledyr <span><i class="fas fa-arrow-right"></i>
            </span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="mb-5"></div>
</main>


<!-- template for the pdf file -->
<div id="print-me" class="magic">

  <table style="width:100%; margin:0; padding:0;" width="100%" border="0" cellpadding="0" cellspacing="0" height="100%">
    <tr style="background-color:#8E62A1;">
      <!-- <td align="left" valign="top" width="20%" style="height: 300px; line-height:250px; padding-left: 80px;"><img src="assets/img/logo-print.png" alt="" title="" /></td>
                  <td  colspan="2"  align="left" valign="top" width="80%" style=" height: 300px; line-height:250px; padding-left: 80px;  font-size:120pt;  color: #fff;">Katt funnet</td> -->
      <td colspan="3" align="left" valign="top" style="height: 300px; line-height:250px;">
        <div style="width:20%; float: left;  padding-left: 80px;"><img class="print-image"
            src="assets/img/logo-print.png" style="width:150px;" alt="" title="" /></div>
        <div style="width:80%; float: left; font-size:120pt;  color: #fff;">{{ pet?.PostTitle }}</div>
      </td>
    </tr>
    <tbody>
      <tr>
        <td colspan="3" width="100%" align="center" valign="top" style="width:100%; padding:10px;">
          <img *ngIf="pet && pet.ThumbnailImagePath" [src]="pet.ThumbnailImagePath" height="600" />
        </td>
      </tr>
      <tr style="border-bottom: 1px solid #eee;">
        <td align="left" valign="top" width="50%"
          style="width:50%; padding-left: 80px; padding-top:20px; padding-bottom:20px;">
          <table cellpadding='0' cellspacing='0' border='0' width='100%'>
            <tr>
              <td align="left" valign="top" width="25%"
                style="padding: 2.2mm 2.2mm; font-size: 30pt; font-weight: bold;">{{"Name" | translate }}</td>
              <td align="left" valign="top" width="75%" style="padding: 2.2mm 2.2mm; font-size: 30pt;">{{pet?.PetName}}
              </td>
            </tr>
          </table>
        </td>
        <td align="left" valign="top" width="50%" style="width:50%; padding-top:20px; padding-bottom:20px;" colspan="2">
          <table cellpadding='0' cellspacing='0' border='0' width='100%'>
            <tr>
              <td align="left" valign="top" width="20%"
                style=" padding: 2.2mm 2.2mm ; font-size: 30pt; font-weight: bold;">{{"Breed" | translate }}</td>
              <td align="left" valign="top" width="80%" style=" padding: 2.2mm 2.2mm; font-size: 30pt;">
                {{pet?.MasterBreed}}</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr style="border-bottom: 1px solid #eee;">
        <td align="left" valign="top" width="50%"
          style="width:50%; padding-left: 80px ;padding-top:20px; padding-bottom:20px;">
          <table cellpadding='0' cellspacing='0' border='0' width='100%'>
            <tr>
              <td align="left" valign="top" width="25%"
                style="padding: 2.2mm 2.2mm; font-size: 30pt; font-weight: bold;">{{ ((pet?.OperationTypeID == "1") ?
                'Lost' : 'Found')| translate }}</td>

              <td align="left" valign="top" width="75%" style=" padding: 2.2mm 2.2mm; font-size: 30pt;">
                {{pet?.DisplayLostFoundDate}}</td>
            </tr>
          </table>
        </td>
        <td align="left" valign="top" width="50" style="width:50%; padding-top:20px; padding-bottom:20px;" colspan="2">
          <table cellpadding='0' cellspacing='0' border='0' width='100%'>
            <tr>
              <td align="left" valign="top" width="20%"
                style=" padding: 2.2mm 2.2mm ; font-size: 30pt; font-weight: bold;">{{"Gender" | translate}}</td>
              <td align="left" valign="top" width="80%" style=" padding: 2.2mm 2.2mm; font-size: 30pt;">{{pet?.Gender}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr style="border-bottom: 1px solid #eee;">
        <td align="left" valign="top" width="50%"
          style="width:50%; padding-left: 80px; padding-top:20px; padding-bottom:20px;">
          <table cellpadding='0' cellspacing='0' border='0' width='100%'>
            <tr>
              <td align="left" valign="top" width="25%"
                style=" padding: 2.2mm 2.2mm; font-size: 30pt; font-weight: bold;">{{"Area" | translate}}</td>
              <td align="left" valign="top" width="75%" style=" padding: 2.2mm 2.2mm; font-size: 30pt;">{{pet?.Area}}
              </td>
            </tr>
          </table>
        </td>
        <td align="left" valign="top" width="50%" style="width:50%; padding-top:20px; padding-bottom:20px;">
          <table cellpadding='0' cellspacing='0' border='0' width='100%' colspan="2">
            <tr>
              <td align="left" valign="top" width="20%"
                style=" padding: 2.2mm 2.2mm ; font-size: 30pt; font-weight: bold;">{{"HairType" | translate}}</td>
              <td align="left" valign="top" width="80%" style="padding: 2.2mm 2.2mm; font-size: 30pt;">{{
                pet?.HairType}}</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr style="border-bottom: 1px solid #eee;">
        <td align="left" valign="top" width="50%"
          style="width:50%; padding-left: 80px; padding-top:20px; padding-bottom:20px;">
          <table cellpadding='0' cellspacing='0' border='0' width='100%'>
            <tr>
              <td align="left" valign="top" width="25%"
                style=" padding: 2.2mm 2.2mm; font-size: 30pt; font-weight: bold;">{{"Address" | translate}}</td>
              <td align="left" valign="top" width="75%" style=" padding: 2.2mm 2.2mm; font-size: 30pt;">
                {{pet?.AddressLine1}} {{' '+pet?.ZipCode +' '+ pet?.City}} </td>
            </tr>
          </table>
        </td>
        <td align="left" valign="top" width="50%"
          style="width:50%; padding-bottom: 160px; padding-top:22px; padding-bottom:20px;">
          <table cellpadding='0' cellspacing='0' border='0' width='100%' colspan="2">
            <tr>
              <td align="left" valign="top" width="20%"
                style=" padding: 2.2mm 2.2mm ; font-size: 30pt; font-weight: bold;">{{"Color" | translate}} </td>
              <td align="left" valign="top" width="80%" style=" padding: 2.2mm 2.2mm; font-size: 30pt;">{{pet?.Color}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td align="left" valign="top" width="100%" colspan="3"
          style="font-size:30pt; padding-left: 80px; font-weight: bold;  padding-top: 50px;" align="left" valign="top">
          {{"Additional Info" | translate}}</td>
      </tr>
      <tr>
        <td align="left" valign="top" width="100%" colspan="3"
          style="font-size:30pt; padding-left: 80px; padding-bottom: 60px;">{{pet?.AdditionalInfo}}</td>
      </tr>
      <tr>
        <td align="left" valign="top" width="100%" colspan="3"
          style="font-size:30pt; padding-left: 80px;  font-weight: bold; " align="left" valign="top">{{"History" |
          translate}}</td>
      </tr>
      <tr>
        <!-- history data here -->
        <td align="left" valign="top" colspan="3" style="font-size:30pt; padding-left: 80px; padding-bottom: 100px;">
        </td>
      </tr>
      <tr>
        <td align="left" valign="top" colspan="3">
          <div style="border:4px solid #000; width: 100%; float: left;">
            <div align="left" valign="top" style="font-size:30pt; padding-left:80px;  width:30%; float: left;">
              <div style="width:100%; float:left; font-size:30px; padding-top:18px;">{{"Contact" | translate}}:</div>
              <div style="font-weight:bold; width:100%; float:left;  font-size:30px;">{{pet?.userContactNumber}}</div>
            </div>
            <div align="center" valign="middle"
              style=" width:40%; height: 150px; line-height: 150px; float: left; background-color: #8E62A1; color: #fff; font-size: 40pt; font-weight:bold; border-left:4px solid #000;  border-right:4px solid #000; ">
              <img src="assets/img/phone-call.png" alt="" title="" /> {{pet?.userContactNumber}}
            </div>
            <div align="left" valign="top"
              style=" width:30%; float: left; font-size:20pt; padding-top: 10px; padding-left: 10px;  ">
              <div style="width:100%; float:left;">
                <div style="width:16%; float: left; vertical-align: top; padding-top: 10px">
                  <qrcode [qrdata]="qrCodeString" [width]="80" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
                  </qrcode>
                </div>
                <div style="width:80%; float: left; vertical-align: top; font-size: 15pt;margin-left: 18px;">
                  Scan QR-koden for å gå <br />
                  til annonsen på <br />
                  dyreid.no.
                </div>
              </div>
              <div
                style="width:100%; float:left; vertical-align: top; font-size: 20pt; font-weight:bold;  padding-top: 1px">
                dyreid.no/{{pet?.LostFoundID}}
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="3" width="100%" align="center" valign="middle"
          style="font-size:20pt; color:#000; padding-top:10px;">Følg dyreid.no</td>
      </tr>
      <tr>
        <td colspan="3" width="100%" align="center" valign="middle" style="padding-top:10px;">
          <a href="#" style="padding-right:15px;"> <img src="assets/img/instagram-icon.png" alt="" title="" /> </a>
          <a href="#" style="padding-right:15px;"> <img src="assets/img/facebook-icon.png" alt="" title="" /> </a>
          <a href="#"> <img src="assets/img/twitter-icon.png" alt="" title="" /> </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>